import { create } from 'zustand';

interface PrefetchStatusStore {
  isPrefetching: boolean;
  isPrefetchComplete: boolean;
  hasInitialized: boolean;
  startPrefetch: () => void;
  completePrefetch: () => void;
  reset: () => void;
}

export const usePrefetchStatus = create<PrefetchStatusStore>((set) => ({
  isPrefetching: false,
  isPrefetchComplete: false,
  hasInitialized: false,
  startPrefetch: () => set({ isPrefetching: true, hasInitialized: true }),
  completePrefetch: () => set({ isPrefetching: false, isPrefetchComplete: true }),
  reset: () => set({ isPrefetching: false, isPrefetchComplete: false, hasInitialized: false }),
}));